import http from "@/http";

async function updateData(key) {
    return http.get(`https://admin.hitribe.com/api/kiosks/${key}`)
}

export {
    updateData
}
